// Used in build.js - do not change to import as Nodejs does not support it

// eslint-disable-next-line import/no-dynamic-require
const appPaths = require(`../apps/${process.env.VUE_APP_NAME}/paths`);

module.exports = {
    ...appPaths,
    payment: "/payment/",
    confirmOrder: "/confirmorder/",
    orderConfirmed: "/orderconfirmed/"
};
